/*
 * Barre « livraison offerte » — Naturel Éthique
 * Rend l'élément <free-shipping-bar> (voir snippets/ne-livraison-offerte.liquid)
 * et le met à jour à chaque modification du panier, sans rechargement.
 */
(function () {
  const BALISE = 'free-shipping-bar';
  const formatteurs = {};

  function formatteMontant(centimes, locale, devise) {
    const cle = locale + '|' + devise;
    if (!formatteurs[cle]) {
      formatteurs[cle] = new Intl.NumberFormat(locale, { style: 'currency', currency: devise });
    }
    return formatteurs[cle].format(centimes / 100);
  }

  if (!customElements.get(BALISE)) {
    customElements.define(
      BALISE,
      class BarreLivraisonOfferte extends HTMLElement {
        connectedCallback() {
          this.seuil = parseInt(this.dataset.seuil, 10) || 0;
          this.message = this.querySelector('[data-fdp-message]');
          this.piste = this.querySelector('[data-fdp-piste]');
          this.jauge = this.querySelector('[data-fdp-jauge]');
          this.afficher(parseInt(this.dataset.total, 10) || 0);
        }

        afficher(total) {
          if (!this.seuil) return;

          const restant = this.seuil - total;
          const atteint = restant <= 0;
          const progression = Math.min(100, Math.round((total * 100) / this.seuil));

          this.classList.toggle('ne-fdp--atteint', atteint);

          if (this.jauge) this.jauge.style.width = progression + '%';
          if (this.piste) this.piste.setAttribute('aria-valuenow', progression);
          if (!this.message) return;

          if (atteint) {
            this.message.textContent = this.dataset.texteAtteint || '';
            return;
          }

          const montant = formatteMontant(restant, this.dataset.locale || 'fr-FR', this.dataset.devise || 'EUR');
          const gabarit = this.dataset.texteRestant || '{montant}';
          const morceaux = gabarit.split('{montant}');
          const fort = document.createElement('strong');
          fort.textContent = montant;

          this.message.textContent = '';
          this.message.append(morceaux[0] || '', fort, morceaux[1] || '');
        }
      }
    );
  }

  // Le script est inclus une fois par emplacement de la barre : on n'abonne
  // qu'une seule fois les mises à jour du panier.
  if (window.neBarreLivraisonOfferteInitialisee) return;
  window.neBarreLivraisonOfferteInitialisee = true;

  function rafraichir() {
    const base = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    fetch(base + '.js')
      .then((reponse) => reponse.json())
      .then((panier) => {
        document.querySelectorAll(BALISE).forEach((barre) => {
          if (typeof barre.afficher === 'function') barre.afficher(panier.total_price);
        });
      })
      .catch(() => {});
  }

  if (typeof subscribe === 'function') {
    const evenement = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';
    subscribe(evenement, rafraichir);
  }
  document.addEventListener('cart:refresh', rafraichir);
})();
